import template from 'template/sign_up/form/reset_password_form';
import BaseFormComponent from "../../../common/component/base_form";
import ResetPasswordRepository from "../repository/reset_password_repository";
import ResetPasswordModel from "../model/reset_password_model";
import MessageDto from "../../../common/dto/message_dto";

export default class ResetPasswordFormComponent extends BaseFormComponent {

    initRepository() {
        this.repository = new ResetPasswordRepository();
    }

    makeNewModel() {
        return new ResetPasswordModel(this.props.cluster);
    }

    onSave(model) {
        this.setState({
            process: false,
            message: new MessageDto(
                'Your password was successfully reset, please check your email for further instructions',
                'success'
            )
        });
    }

    render() {
        return template.bind(this)();
    }

}